import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "id", "className"];
import TrackedButton from '../../TrackedButton';
import useMenuItem from '../hooks/useMenuItem';
import { jsx as _jsx } from "react/jsx-runtime";
export const MenuItemButton = _ref => {
  let {
      children,
      id,
      className
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    menuItemId,
    setRef,
    onMenuItemKeyDown,
    tabIndex
  } = useMenuItem({
    id
  });
  return /*#__PURE__*/_jsx("li", {
    role: "menuitem",
    className: className,
    children: /*#__PURE__*/_jsx(TrackedButton, Object.assign({
      id: menuItemId,
      ref: setRef,
      onKeyDown: onMenuItemKeyDown,
      tabIndex: tabIndex
    }, rest, {
      children: children
    }))
  });
};